import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
  },
  textWrapper: {
    flex: 1,
    marginRight: theme.spacing(2.5),
  },
  label: {
    color: theme.palette.text.lightGrey,
    paddingRight: theme.spacing(1),
    textAlign: 'justify',
  },
  error: {
    color: theme.palette.error.main,
  },
  uploadCtaWrapper: {
    '& input[type=file]': {
      display: 'none',
      visibility: 'hidden',
    },
  },
  uploadCta: {
    borderRadius: 40,
    '[lang=ar] &': {
      alignItems: 'end',
      '&>span': {
        paddingBottom: 4,
      },
    },
  },
  errorCta: {
    borderColor: theme.palette.error.main,
  },
}))
